import React, { CSSProperties, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { isValid, parseISO, isDate } from 'date-fns';
import debounce from '@material-ui/core/utils/debounce';
import { SymbolDiv, VcGrid } from 'components/Grid';
import { dMaFormatP } from 'main_consts';
import { dateTypingChange } from 'main_func';
import { makeStyles } from '@material-ui/core';
import DatePickerTyping from './DatePickerTyping';
import { IupdateObj } from '.';
import { seDateVerify } from './consts';

interface IMonthOneSePickersTyping {
  inputDataName: string;
  required?: boolean;
  disabled?: boolean;
  mainClass?: string;
  verifyError?: boolean;
  data: unknown;
  updateData: (updateObj: IupdateObj) => void;
  style: CSSProperties;
  seInterval?: number;
}

const useStyles = makeStyles(() => ({
  errorText: {
    '& .MuiFormHelperText-root': { fontSize: '1em' },
  },
}));

const MonthOneSePickersTyping = (
  props: IMonthOneSePickersTyping
): JSX.Element => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const {
    inputDataName,
    required = false,
    mainClass,
    verifyError,
    data: dataTemp,
    updateData,
    style = {},
    seInterval,
    disabled = false,
  } = props;

  const data = dataTemp as IupdateObj<string>;

  const [updDate, setUpdDate] = useState<Date | null>(null);

  useEffect(() => {
    const valueDate = [parseISO(data[inputDataName])].map((obj) =>
      isValid(obj) ? obj : null
    );

    setUpdDate(valueDate[0]);

    const nullOrValid = (d: string | Date | null) => d === null || isValid(d);

    updateData({
      [`${inputDataName}Valid`]: nullOrValid(valueDate[0]),
    });
  }, [data[inputDataName]]);

  const Pickers = [
    <DatePickerTyping
      className={classes.errorText}
      disabled={disabled}
      required={required}
      verifyBeforeChange={verifyError}
      format={dMaFormatP}
      value={updDate}
      onChange={(date) => {
        setUpdDate(date);
        const name = inputDataName;
        dateTypingChange(updateData)(name)(date);
        if (isValid(date)) {
          const func = debounce(() => {
            isDate(date);
          });
          func();
        }
      }}
    />,
  ];

  return (
    <VcGrid container className={mainClass} style={{ ...style, width: '100%' }}>
      <VcGrid item xs>
        {Pickers[0]}
      </VcGrid>
    </VcGrid>
  );
};

export default MonthOneSePickersTyping;
